import React from "react";
import { ContextLanguage } from "../../../context/Context.Language";
import {
  STYLE_BODY_2_REGULAR,
  STYLE_LINK_BLUE,
  STYLE_LINK_BLUE_NO_MX,
  STYLE_UNDERLINE_BLUE_SELECTPROGRAM,
} from "../../../utils/useStyle";
import {
  LAST_TIME_YOU_STILL_CAN_BOOK,
  RETURN_SAME_DAY,
  RETURN_SHOSE_TIME,
  RETURN_TIME,
  TEXT_CREATE,
  TIME_THAT_STILL_SAME_DAY_SERVICE,
} from "../../../utils/useConstants";
import { useNavigate } from "react-router-dom";

export const STYLE_BODY_3_REGULAR = (language) => {
  if (language === "TH") {
    return "my-10 text-lg-th md:text-xl-th text-laundry-gray-100 leading-6 font-normal ";
  } else {
    return "my-10 text-lg md:text-xl text-laundry-gray-100 leading-6 font-normal ";
  }
};

const style_title =
  " font-bold text-22 md:text-28 md:leading-8.3 text-laudry-gray-200 mt-11 mb-6 flex items-center justify-center gap-1 style-title";
const HomeText = () => {
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  if (language === "TH") {
    return (
      <div
        className={`text-center mt-5 px-4 md:px-10 xl:px-37 mx-auto max-w-desktop -mb-12`}
      >
        <div className={style_title}>
          ซัก รีด ซักรองเท้า กรุงเทพ | รับส่งฟรี
        </div>
        <div className={STYLE_UNDERLINE_BLUE_SELECTPROGRAM}></div>
        <div className={`${STYLE_BODY_2_REGULAR(language)} mb-6`}>
          <span className="font-semibold"> เวลาจัดส่ง:</span>{" "}
          สั่งออเดอร์ได้ทุกวันก่อน {LAST_TIME_YOU_STILL_CAN_BOOK}:00 น.
          แล้วเราจะไปรับทันที โดยปกติเร็วกว่า 60 นาที! เรา
          <span className="font-semibold">รับประกัน</span>
          ว่าจะส่งคืนทุกออเดอร์ในวันถัดไป: เสื้อผ้าและเครื่องนอนภายใน{" "}
          {RETURN_TIME}:00 น. รองเท้าหรือออเดอร์รวมผ้ากับรองเท้าภายใน{" "}
          {RETURN_SHOSE_TIME}:00 น. สะดวกและรวดเร็ว!
          เมื่อส่งคืนออเดอร์เรียบร้อยแล้ว เราจะส่งอีเมลแจ้งคุณทันที!
        </div>
        <div className={`${STYLE_BODY_2_REGULAR(language)} mb-6`}>
          <span className="font-semibold">
            ใช้งานอย่างไร: บริการไร้การสัมผัส
          </span>
          ของเราช่วยคุณประหยัดเวลา - คุณไม่ต้องรอการรับส่งคืนออเดอร์เลย! ง่ายๆ
          แค่ฝากออเดอร์ไว้ที่ล็อบบี้หรือแผนกต้อนรับของโรงแรม จุดรับส่งของคอนโด
          รปภ. หรืออื่นๆ เราจะไปรับและส่งคืนที่นั่น! สําคัญโปรดระบุจุด
          <span className="font-semibold">รับส่ง</span>
          และ<span className="font-semibold">เลขที่ห้อง</span>ให้ชัดเจนใน
          <span className="font-semibold">กล่องสีแดง</span>
          ในหน้าตะกร้าก่อนสั่งออเดอร์
          <br />
        </div>
        <div className={`${STYLE_BODY_2_REGULAR(language)} mb-6`}>
          <span className="font-semibold">เราสัญญาว่า</span>
          จะส่งคืนทุกออเดอร์ก่อนเวลาเสมอ หากออเดอร์เรียบร้อยแล้ว อย่างไรก็ตาม
          หากต้องการให้เรารับประกันส่งคืนภายใน{RETURN_SAME_DAY}:00 น.
          ของวันเดียวกัน กรุณาเลือกบริการส่งคืนด่วนในวันเดียวกันก่อน{" "}
          {TIME_THAT_STILL_SAME_DAY_SERVICE}:00 น.
        </div>
        <div className={`${STYLE_BODY_2_REGULAR(language)}`}>
          <span
            onClick={() => {
              navigate("/OurServices");
            }}
            className={`${STYLE_LINK_BLUE_NO_MX} cursor-pointer`}
          >
            {TEXT_CREATE[language]}
          </span>{" "}
          ตอนนี้เลย!
        </div>
      </div>
    );
  } else {
    return (
      <div
        className={`text-center mt-5 px-4 md:px-10 xl:px-37 mx-auto max-w-desktop -mb-12`}
      >
        <div className={style_title}>
          Laundry & Shoe Cleaning Service Bangkok | FREE Delivery
        </div>
        <div className={STYLE_UNDERLINE_BLUE_SELECTPROGRAM}></div>
        <div className={`${STYLE_BODY_2_REGULAR(language)} mb-6`}>
          <span className="font-semibold"> Timing:</span> Place your order any
          day of the week before {LAST_TIME_YOU_STILL_CAN_BOOK}:00, and we will
          come to pick it up immediately, typically in less than 60 mins! We
          GUARANTEE next-day return for all orders: Laundry by {RETURN_TIME}:00
          noon, shoes or combined shoes & laundry orders by {RETURN_SHOSE_TIME}
          :00 - fast & easy! When your order is returned you will be instantly
          notified via mail!
        </div>
        <div className={`${STYLE_BODY_2_REGULAR(language)} mb-6`}>
          <span className="font-semibold">How It Works:</span> Our service is
          fully CONTACTLESS to save your valuable time - you never need to wait
          for us, neither for pick up nor for return! You can conveniently leave
          your order at the lobby, reception, drop-off table, security guard or
          any other place - we will pick it up and return it there! Just specify
          the exact SPOT where we can pick up and return your order together
          with your ROOM NUMBER in the RED BOX in the basket before placing your
          order!
        </div>
        <div className={`${STYLE_BODY_2_REGULAR(language)} mb-6`}>
          <span className="font-semibold">Express Service Promise:</span> We
          will always return your order ahead of schedule, whenever possible!
          However, for a GUARANTEED same-day return by {RETURN_SAME_DAY}:00,
          please activate our Same Day Express Service before{" "}
          {TIME_THAT_STILL_SAME_DAY_SERVICE}:00 noon.
        </div>
        <div className={`${STYLE_BODY_2_REGULAR(language)} mb-6`}>
          <span
            onClick={() => {
              navigate("/OurServices");
            }}
            className={`${STYLE_LINK_BLUE_NO_MX} cursor-pointer`}
          >
            {TEXT_CREATE[language]}
          </span>{" "}
          an order now!
        </div>
      </div>
    );
  }
};

export default HomeText;
